import Modal from '../../Modal';
import { CommentCart } from '../CommentCard';
import { Grid } from '@material-ui/core';
import { Comment } from '../../../../domain/models/Comment';
import { PaginatedResponse } from '../../../../domain/models/PaginatedResponse';
import { NewComment } from '../NewComment';
import { NewCommentEventListener } from '../NewComment/props';

type Props = {
  onClose: Function;
  onNewComment: NewCommentEventListener;
  comments: PaginatedResponse<Comment>;
  title?: string;
};

export const CommentsModal = ({
  onClose,
  onNewComment,
  comments,
  title,
}: Props) => {
  return (
    <Modal open={true} onClose={onClose} title={title || 'Comentarios'}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <NewComment onSubmit={onNewComment} autoloading />
        </Grid>
        {comments.data.map((comment, key) => (
          <Grid item xs={12} key={`comment-list-i-${key}`}>
            <CommentCart {...comment}></CommentCart>
          </Grid>
        ))}
        {/* <Grid xs={12} container alignItems='center' alignContent='center' justifyContent='center'>
          <Button type='button' variant="contained" color="primary">Cargar más antiguos</Button>
        </Grid> */}
      </Grid>
    </Modal>
  );
};
